import getSiblings from "./getSiblings.js"
import { toggleSlide, slideUp } from "./toggleSlide.js"

const DELAY = 250

// Add accordion effect to FAQ section
export default function useFAQaccordion () {
    function handleSectionHeaderClick ( event ) {
        event.preventDefault()
        const header = event.currentTarget
        const section = header.parentNode
        const isCurrent = section.classList.contains( "accordion__section--current" )
        const siblings = getSiblings( section )
        const filteredSiblings = siblings.filter( ( el ) => el.classList.contains( "accordion__section--current" ) )

        filteredSiblings.forEach( ( sibilingSection ) => {
            setTimeout( async () => {
                sibilingSection.classList.remove( "accordion__section--current" )

                const sectionBody = sibilingSection.querySelector( ".accordion__body" )
                await slideUp( sectionBody, DELAY )

                return
            }, 0 )
        })

        setTimeout( async () => {
            section.classList.toggle( "accordion__section--current", !isCurrent )
            const sectionBody = section.querySelector( ".accordion__body" )
            await toggleSlide( sectionBody, DELAY )

            return
        }, 0 )
    }

    function init () {
        const sectionsBodies = document
            .querySelectorAll( ".accordion__section:not(.accordion__section--current) .accordion__body" )

        sectionsBodies.forEach( ( sectionBody ) => {
            sectionBody.style.display = "none"
        })

        const sectionsHeader = document.querySelectorAll( ".accordion__head" )

        sectionsHeader.forEach( ( header ) => {
            header.addEventListener( "click", handleSectionHeaderClick )
        })
    }

    init()
}
